









































import { Vue } from "vue-property-decorator";
import { mapState, mapActions, mapGetters } from "vuex";
import AppLayout from "@/components/app-layout.vue";
import AppAdo from "@/components/app-ado.vue";
import router from "@/router/";
import api from "@/http/api.ts";
import { Pointage } from "@/store/types";
import store from "@/store";
import { Etablissement } from "@/models/Etablissement";
import etablissementList from "@/features/etablissements/components/etablissement-list.vue";

export default Vue.extend({
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("etablissements/fetchListEtablissements")
      .then(function(rep: any) {
        rep === "MonoEtab" ? next("/home") : next();
      })
      .catch(function(error: any) {
        console.error(error);
      });
  },
  components: {
    AppLayout,
    AppAdo,
    etablissementList
  },
  data() {
    return {
      etablissements: []
    };
  },
  computed: { ...mapGetters("etablissements", ["getlistEtablissement"]) },
  methods: {
    ...mapActions("etablissements", ["selectEtablissement"]),

    etablissementClick($event: Etablissement) {
      this.selectEtablissement($event);
    }
  }
});
